import { render, staticRenderFns } from "./EloadTransactions.vue?vue&type=template&id=496f81ae"
import script from "./EloadTransactions.vue?vue&type=script&lang=js"
export * from "./EloadTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports